
import { db } from '@/main'
import Mixin from '@/mixin'
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
@Component
export default class DialogPremium extends mixins(Mixin) {
  @Prop() type
  @Prop() user
  dialog_premium = false
  selectedDate: any = null
  dateFormatted = new Date().toISOString().substr(0, 10)
  menu = false
  isLoading = false
  finalUser = null

  showDialog(){
    console.log(this.type)
    this.finalUser = JSON.parse(JSON.stringify(this.user))
    console.log(this.finalUser)
    if(this.type === "edit"){
        console.log("Is edit")
        const endDate = this.user.premium_end.toDate()
        endDate.setDate(endDate.getDate()-1)
        this.dateFormatted = endDate.toISOString().substr(0, 10)
    }   
    this.dialog_premium = true
  }

  @Watch("dateFormatted")
  onDateFormattedChange(val){
    this.selectedDate = new Date(val)
    this.selectedDate.setHours(23)
    this.selectedDate.setMinutes(59)
    this.selectedDate.setSeconds(59)
    console.log(this.selectedDate)
  }

  async updateUserPremium() {
    try {
        this.isLoading = true 
        this.showNotification("loading", "Actualizando usuario", "un momento por favor", 3000)
        const finalDate = new Date(this.selectedDate);
        const finalEndDateTime = new Date(
          finalDate.getFullYear(),
          finalDate.getMonth(),
          finalDate.getDate() + 1,
          23,
          59,
          59
        );
        await db.collection("users").doc(this.user.uid).update({premium: this.finalUser!['premium'], premium_start: new Date(), premium_end: finalEndDateTime, subscription_type: "Custom"})
        this.showNotification("success", "Usuario premium", "Se editó el usuario", 3000)
        this.dialog_premium = false
        this.isLoading = false
    } catch (error) {
        console.log(error)
        this.showNotification("fail", "Error", "Ocurrió un error al editar el usuario", 3000)
        this.dialog_premium = false
        this.isLoading = false
    }
  }

  parseDate(date) {
    if (!date) return null;

    const [month, day, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
}
